import type { StreamingLifecycleCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/streaming-lifecycle-commands';

import { log } from '../utils/aifc-logging';

import { CommandHandler } from './command-handler';
import type { PassThroughCommandProps } from './command-handler';

export class StreamErroredCommandHandler extends CommandHandler<
	StreamingLifecycleCommandProperties,
	void
> {
	constructor(
		props: PassThroughCommandProps,
		private onError: (command: StreamingLifecycleCommandProperties) => void,
	) {
		super(props);
	}

	execute(command: StreamingLifecycleCommandProperties): void {
		log('handle rovo-stream-errored-command');
		try {
			this.onError(command);
		} catch {
			// TODO: EDITOR-123 - report this error
		}
	}
}
